/**
 * Šalutinių gyvūninių produktų (ŠGP) kategorija pagal ABP Reg. 1069/2009.
 * Atspindi backend `OKIS.Domain.Shared.Activities.SgpCategory` enum.
 * Saugoma kaip `int[]` PostgreSQL stulpelyje `activity.sgp_categories`.
 */
export enum SgpCategory {
	Category1 = 1,
	Category2 = 2,
	Category3 = 3,
}
